import { TestSimple } from './test';

export interface FormCustomization {
  customization_field: 'Veterinarian Box' | 'Spec Test Req Box';
  customization_type: 'Vet' | 'Note' | 'Test';
  customization_data: string;
  order: number;
  test_code: number | null;
}

export interface FormCustomizationInternal {
  veterinarians: string[];
  notes: string;
  codes: TestSimple[];
}

export const toInternal = (
  customizations: FormCustomization[]
): FormCustomizationInternal => ({
  veterinarians: customizations
    .filter(c => c.customization_type === 'Vet')
    .map(c => c.customization_data),
  notes: customizations
    .filter(c => c.customization_type === 'Note')
    .map(c => c.customization_data)
    .join('\n'),
  codes: customizations
    .filter(c => c.customization_type === 'Test')
    .map(c => ({ id: c.test_code, name: c.customization_data }))
});

export const fromInternal = (
  customization: FormCustomizationInternal
): FormCustomization[] => [
  ...customization.veterinarians.map(
    (v, i): FormCustomization => ({
      customization_field: 'Veterinarian Box',
      customization_type: 'Vet',
      customization_data: v,
      test_code: null,
      order: i
    })
  ),
  ...customization.notes
    .split('\n')
    .map(
      (n, i): FormCustomization => ({
        customization_field: 'Spec Test Req Box',
        customization_type: 'Note',
        customization_data: n,
        test_code: null,
        order: i
      })
    )
    .filter(c => c.customization_data.length > 0),
  ...customization.codes
    .filter(c => c.id)
    .map(
      (c, i): FormCustomization => ({
        customization_field: 'Spec Test Req Box',
        customization_type: 'Test',
        customization_data: c.name,
        test_code: c.id,
        order: i
      })
    )
];
